module.exports = __webpack_public_path__ + "img/cloud-connection.dd795d47.svg";